// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"3a9b357e471238c7","9777":"ae1a0803deced879"}[chunkId] + ".js";
};